import { HTMLAttributes } from 'react'

import Builder from '@/components/layout/Builder'
import HeroCollection from '@/components/sections/HeroCollection'

import { WPPageData } from '@/types'

export type ProductProps = HTMLAttributes<HTMLElement> & {
  pageData?: WPPageData
}

const Product = ({ pageData }: ProductProps) => {
  return (
    <>
      {pageData ? (
        //@ts-ignore
        <HeroCollection item={[pageData]} />
      ) : null}
      <Builder pageData={pageData} />
    </>
  )
}

export default Product
